import { ReactElement } from 'react';

import { clearFirebase, NavigateTo } from '@neo.tax/shared';

export const Logout = (): ReactElement => {
  // This will trigger `onAuthenticationStateChange` found in `useAuthenticationService`
  // which will in turn handle all the necessary logout logic.
  clearFirebase();

  return <NavigateTo to="/login" />;
};
